// Single source of truth for brand name and Saflens Cloud contact
// addresses/domain referenced across legal/docs pages. Pages should import
// these constants instead of repeating the literal strings, so a future
// rebrand or domain change is a one-line edit here, not a find/replace
// across every page that mentions a support/legal/privacy email.

export const BRAND_NAME = 'Saflens';

// The real Saflens Cloud domain — intentionally NOT derived from
// VITE_API_URL/same-origin, since these are legal/support contact details
// for the hosted SaaS product specifically, not "wherever this self-hosted
// instance happens to be running".
export const CLOUD_DOMAIN = 'saflens.app';
export const CLOUD_URL = `https://${CLOUD_DOMAIN}`;

export const SUPPORT_EMAIL = `support@${CLOUD_DOMAIN}`;
export const LEGAL_EMAIL = `legal@${CLOUD_DOMAIN}`;
export const PRIVACY_EMAIL = `privacy@${CLOUD_DOMAIN}`;
export const GDPR_EMAIL = `gdpr@${CLOUD_DOMAIN}`;
export const DPO_EMAIL = `dpo@${CLOUD_DOMAIN}`;

export const mailto = (email: string) => `mailto:${email}`;
